export default __webpack_public_path__ + "static/media/main-banner-producer.c95b5ba6.png";